import postBasket from './postBasket'
import setValue from './setValue'
import { BASKET_DATA } from './setBasketState'
import selectedRoomOptions from '../selectors/selectedRoomOptions'

const shoppingCartAttempt = async (dispatch, state, getNewRooms) => {
  const params = selectedRoomOptions(state)

  if (params) {
    dispatch(postBasket(params, null, getNewRooms))
  } else {
    dispatch(setValue(BASKET_DATA, null))
  }
}

export default
getNewRooms => (dispatch, getState) => shoppingCartAttempt(dispatch, getState(), getNewRooms)
